namespace $ {

	/** Faces count native Gift/Sand units per peer. Matching clocks alone are not
	 * sufficient: a missing unit with an old clock still requires native resync. */
	export function $shm_hitalama_baza_diff_idle_equal(
		local: $giper_baza_face_map,
		remote?: $giper_baza_face_map,
	) {
		if( !local.size || !remote?.size ) return false
		for( const [ , face ] of remote ) {
			if( !Number.isSafeInteger( face.summ ) || face.summ < 0 ) return false
		}
		for( const [ peer, face ] of local ) {
			const other = remote.get( peer )
			if( !other || other.time_tick !== face.time_tick || other.summ !== face.summ ) return false
		}
		return true
	}

	export function $shm_hitalama_baza_diff_idle(
		native: $giper_baza_land['diff_units'],
		land: $giper_baza_land,
		faces?: $giper_baza_face_map,
	): $giper_baza_unit[] {
		if( faces?.size ) {
			// Loading, encoding and signing remain mandatory. A pending local write
			// can change the faces here, before deciding whether a delta is empty.
			land.units_signing()
			if( $shm_hitalama_baza_diff_idle_equal( land.faces, faces ) ) {
				// Faces themselves are plain Maps. Keep the native dictionary pubs:
				// signing() returns void and cannot propagate every data replacement.
				// size() subscribes to the same pub as values(), even at equal size.
				land._gift.size
				for( const peers of land._sand.values() ) for( const units of peers.values() ) units.size
				return []
			}
		}
		return native.call( land, faces )
	}

	const $shm_hitalama_baza_diff_idle_installed = new WeakSet< object >()

	/** Owned adapter: do not change upstream loading/audit or nonempty selection. */
	export function $shm_hitalama_baza_diff_idle_install( Type = $giper_baza_land ) {
		const proto = Type.prototype
		if( $shm_hitalama_baza_diff_idle_installed.has( proto ) ) return
		$shm_hitalama_baza_diff_idle_installed.add( proto )
		const native = proto.diff_units
		proto.diff_units = function( faces ) {
			return $shm_hitalama_baza_diff_idle( native, this, faces )
		}
	}

}
